<script setup lang="ts">
import { BoothColors } from '@/lib/booth'
import { StallColors } from '@/lib/stall';

definePageMeta({
  title: "展示・模擬店",
})
</script>

<template>
  <article class="flex flex-col items-center max-w-[900px] mx-auto px-[8px]">
    <Ribbon class="mt-6 mb-8 text-md md:text-2xl">
      学部展・課外活動展など
    </Ribbon>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-4 mb-6">
      <NuxtLink class="btn text-xl h-14 btn-outline text-gray-700 hover:text-gray-700 hover:bg-stone-200 border-2 "
        :style="{ 'border-color': BoothColors['課外活動展'] }" to="/booth/orgs/kagai">
        課外活動展
      </NuxtLink>
      <NuxtLink class="btn text-xl h-14 btn-outline text-gray-700 hover:text-gray-700 hover:bg-stone-200 border-2 "
        :style="{ 'border-color': BoothColors['文学部展'] }" to="/booth/orgs/bun">
        文学部展
      </NuxtLink>
      <NuxtLink class="btn text-xl h-14 btn-outline text-gray-700 hover:text-gray-700 hover:bg-stone-200 border-2 "
        :style="{ 'border-color': BoothColors['収穫祭・農学部展'] }" to="/booth/orgs/nou">
        収穫祭・農学部展
      </NuxtLink>
      <NuxtLink class="btn text-xl h-14 btn-outline text-gray-700 hover:text-gray-700 hover:bg-stone-200 border-2 "
        :style="{ 'border-color': BoothColors['テクノフェスタ・工学部展'] }" to="/booth/orgs/kou">
        テクノフェスタ・工学部展
      </NuxtLink>
      <NuxtLink class="btn text-xl h-14 btn-outline text-gray-700 hover:text-gray-700 hover:bg-stone-200 border-2 "
        :style="{ 'border-color': BoothColors['経営学部展'] }" to="/booth/orgs/keiei">
        経営学部展
      </NuxtLink>
      <NuxtLink class="btn text-xl h-14 btn-outline text-gray-700 hover:text-gray-700 hover:bg-stone-200 border-2 "
        :style="{ 'border-color': BoothColors['教育学部展'] }" to="/booth/orgs/kyouiku">
        教育学部展
      </NuxtLink>
      <NuxtLink class="btn text-xl h-14 btn-outline text-gray-700 hover:text-gray-700 hover:bg-stone-200 border-2 "
        :style="{ 'border-color': BoothColors['芸術学部展'] }" to="/booth/orgs/geijutsu">
        芸術学部展
      </NuxtLink>
      <NuxtLink class="btn text-xl h-14 btn-outline text-gray-700 hover:text-gray-700 hover:bg-stone-200 border-2 "
        :style="{ 'border-color': BoothColors['リベラルアーツ学部展'] }" to="/booth/orgs/lbarts">
        リベラルアーツ学部展
      </NuxtLink>
      <NuxtLink class="btn text-xl h-14 btn-outline text-gray-700 hover:text-gray-700 hover:bg-stone-200 border-2 "
        :style="{ 'border-color': BoothColors['観光学部展'] }" to="/booth/orgs/kankou">
        観光学部展
      </NuxtLink>
      <NuxtLink class="btn text-xl h-14 btn-outline text-gray-700 hover:text-gray-700 hover:bg-stone-200 border-2 "
        :style="{ 'border-color': BoothColors['研究所'] }" to="/booth/orgs/kenkyujo">
        研究所
      </NuxtLink>
      <NuxtLink class="btn text-xl h-14 btn-outline text-gray-700 hover:text-gray-700 hover:bg-stone-200 border-2 "
        :style="{ 'border-color': BoothColors['大学関連団体'] }" to="/booth/orgs/dantai">
        大学関連団体
      </NuxtLink>
    </div>

    <Ribbon class="mt-6 mb-8 text-md md:text-2xl">
      模擬店
    </Ribbon>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-4 mb-6">
      <NuxtLink
        class="btn text-xl h-16 btn-outline text-gray-700 hover:text-gray-700 hover:bg-stone-200 border-2 flex flex-col"
        :style="{ 'border-color': StallColors['A'] }" to="/booth/areas/a">
        [A] 玉川池前
      </NuxtLink>
      <NuxtLink
        class="btn text-xl h-16 btn-outline text-gray-700 hover:text-gray-700 hover:bg-stone-200 border-2 flex flex-col"
        :style="{ 'border-color': StallColors['B'] }" to="/booth/areas/b">
        [B] 大学教育棟 2014 2F 入り口前
      </NuxtLink>
      <NuxtLink
        class="btn text-xl h-16 btn-outline text-gray-700 hover:text-gray-700 hover:bg-stone-200 border-2 flex flex-col"
        :style="{ 'border-color': StallColors['C'] }" to="/booth/areas/c">
        [C] 大学教育棟 2014 4F 入り口前
      </NuxtLink>
      <NuxtLink
        class="btn text-xl h-16 btn-outline text-gray-700 hover:text-gray-700 hover:bg-stone-200 border-2 flex flex-col"
        :style="{ 'border-color': StallColors['D'] }" to="/booth/areas/d">
        [D] 礼拝堂前
      </NuxtLink>
      <NuxtLink
        class="btn text-xl h-16 btn-outline text-gray-700 hover:text-gray-700 hover:bg-stone-200 border-2 flex flex-col"
        :style="{ 'border-color': StallColors['E'] }" to="/booth/areas/e">
        [E] STREAM Hall 2019 前
      </NuxtLink>
      <NuxtLink
        class="btn text-xl h-16 btn-outline text-gray-700 hover:text-gray-700 hover:bg-stone-200 border-2 flex flex-col"
        :style="{ 'border-color': StallColors['F'] }" to="/booth/areas/f">
        [F] University Concert Hall 2016 前
      </NuxtLink>
      <NuxtLink
        class="btn text-xl h-16 btn-outline text-gray-700 hover:text-gray-700 hover:bg-stone-200 border-2 flex flex-col"
        :style="{ 'border-color': StallColors['G'] }" to="/booth/areas/g">
        [G] ELF Study Hall 2015 前
      </NuxtLink>
      <NuxtLink
        class="btn text-xl h-16 btn-outline text-gray-700 hover:text-gray-700 hover:bg-stone-200 border-2 flex flex-col"
        :style="{ 'border-color': StallColors['H'] }" to="/booth/areas/h">
        [H] 経塚オフィス棟前
      </NuxtLink>
      <NuxtLink
        class="btn text-xl h-16 btn-outline text-gray-700 hover:text-gray-700 hover:bg-stone-200 border-2 flex flex-col"
        :style="{ 'border-color': StallColors['I'] }" to="/booth/areas/i">
        [I] Consilience Hall 2020 前
      </NuxtLink>
      <NuxtLink
        class="btn text-xl h-16 btn-outline text-gray-700 hover:text-gray-700 hover:bg-stone-200 border-2 flex flex-col"
        :style="{ 'border-color': StallColors['J'] }" to="/booth/areas/j">
        [J] 農場
      </NuxtLink>
      <NuxtLink
        class="btn text-xl h-16 btn-outline text-gray-700 hover:text-gray-700 hover:bg-stone-200 border-2 flex flex-col"
        :style="{ 'border-color': StallColors['K'] }" to="/booth/areas/k">
        [K] その他
      </NuxtLink>
    </div>
  </article>
</template>